import React, { useEffect, useState } from 'react'

import { describeBytes } from 'util/index'
import { getBucketItems } from '../service/store.service'
import { formatDateTime } from 'util/masks'
import { StorageItemRefTypeDict } from 'util/services/upload'
import { getDefaultStorageItemsFilter } from '../hooks/getDefaultFilters'

import '../styles/Storage.scss'
import Pagination from 'util/modules/Pagination'
import { useHistory } from 'react-router-dom'
import { DeleteStorageItems } from './delete.storage'

export const StoreItemList: React.FC = () => {
  const history = useHistory()

  const [selected, setSelected] = useState<string[]>([])

  const filter = getDefaultStorageItemsFilter()
  const { data } = getBucketItems(filter)

  const filterToUrlString = () => {
    const searchParams = new URLSearchParams(history.location.search)

    searchParams.set('page', String(filter.page))
    searchParams.set('limit', String(filter.limit))
    if (filter.filter) {
      if (filter.filter.name) searchParams.set('filter.name', filter.filter.name)
      if (filter.filter.date?.start) searchParams.set('filter.date.start', filter.filter.date.start)
      if (filter.filter.date?.end) searchParams.set('filter.date.end', filter.filter.date.end)
    }

    searchParams.set('order.by', filter.order.by)
    searchParams.set('order.direction', filter.order.direction)

    return searchParams
  }

  useEffect(() => {
    setSelected([])
  }, [filter.page])

  const lastPage = Math.ceil(data.total / filter.limit)

  return (
    <div className="list border-radius" style={{ marginTop: 16 }}>
      <div className="list-header">
        <div>
          <input
            type='checkbox'
            checked={data.items.length > 0 && selected.length === data.items.length}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                setSelected(data.items.map(item => item.id))
              } else {
                setSelected([])
              }
            }}
          />
        </div>
        <div>Nome</div>
        <div>Tipo</div>
        <div>Tamanho</div>
        <div>Data</div>
      </div>

      {
        data.items.length === 0 && (
          <div className="list-row empty">
            <div className="grid-span" style={{ height: 0 }}>Nenhum arquivo encontrado</div>
          </div>
        )
      }

      {
        data.items.map((item, i) => {
          return (
            <div className="list-row" key={i}>
              <div data-content="Marcar">
                <input
                  type="checkbox"
                  checked={selected.includes(item.id)}
                  onClick={() => {
                    if (selected.includes(item.id)) {
                      setSelected(selected.filter(id => id !== item.id))
                    } else {
                      setSelected([...selected, item.id])
                    }
                  }}
                />
              </div>
              <div data-content="Nome">
                <a href={item.url} target='__blank'>
                  <i className="fa fa-link"></i> {item.originalFileName}
                </a>
              </div>
              <div data-content="Tipo">{StorageItemRefTypeDict[item.refType]}</div>
              <div data-content="Tamanho">{describeBytes(item.size)}</div>
              <div data-content="Data">{formatDateTime(item.date)}</div>
            </div>
          )
        })
      }

      <div
        className="row"
        style={{
          display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
        }}
      >
        <DeleteStorageItems ids={selected} />
        <div className="row padding-16">
          <Pagination
            pagination={{
              limit: filter.limit,
              page: filter.page,
              total: data.total,
              lastPage,
              links: {
                next: (() => {
                  const searchParams = filterToUrlString()
                  searchParams.set('page', String(Math.min(lastPage, filter.page + 1)))
                  return searchParams.toString()
                })(),
                first: (() => {
                  const searchParams = filterToUrlString()
                  searchParams.set('page', '1')
                  return searchParams.toString()
                })(),
                last: (() => {
                  const searchParams = filterToUrlString()
                  searchParams.set('page', String(lastPage))
                  return searchParams.toString()
                })(),
                prev: (() => {
                  const searchParams = filterToUrlString()
                  searchParams.set('page', String(Math.max(1, filter.page - 1)))
                  return searchParams.toString()
                })()
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}
